import Hero from "../components/Hero";
import Features from "../components/Features";
import DomainValue from "../components/DomainValue";
import BlogPreview from "../components/BlogPreview";
import { Link } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
function HomePage() {
  return (
    <>
      <Hero />
      <Features />
      <DomainValue />
      <BlogPreview />
      {/* CTA Section */}
      <section
        className="relative py-16 bg-cover bg-center"
        style={{ backgroundImage: "url('/background4.webp')" }}
      >
        {/* 🔥 Full-Width Overlay */}
        <div className="absolute inset-0 bg-black/40"></div>

        {/* Content Container */}
        <div className="relative container-custom text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Interested in Acquiring WholeFoods.ai?
          </h2>
          <p className="text-xl text-white/90 mb-8 max-w-3xl mx-auto">
            Don't miss this opportunity to own a premium domain at the
            intersection of AI technology and sustainable nutrition.
          </p>
          <Link
            to="/contact"
            className="btn-primary bg-white text-accent hover:bg-gray-100 inline-flex items-center"
          >
            <ShoppingBag className="mr-2 h-5 w-5" />
            Inquire About This Domain
          </Link>
        </div>
      </section>
    </>
  );
}

export default HomePage;
